/**
 * KitNextBand -- the RECORD-PAGE archetype's NEXT band (zone 3).
 *
 * Law homes (cited, never re-derived here):
 *  - RECORD-PAGE archetype, zone 3 NEXT BAND: ONE loud sentence (the derived
 *    next lawful action) + ONE emphasized primary action (invokes its
 *    relocated control in place, or anchors to a permanent rail section) + a
 *    composer gated behind invocation ("Log activity", collapsed by default,
 *    native `[hidden]`, never conditionally unmounted).
 *    docs/design/design-language/07-BEHAVIOURAL-LAWS.md ("### ARCH", UPDATE 2,
 *    zone 3).
 *  - FIVE-SECOND LAW (07 "### 5SEC"): the NEXT band is the loudest line after
 *    identity -- what to do next resolves without scrolling.
 *  - ANNOTATION-LAYER RIDER (07 "### ARCH" UPDATE 2): mockup annotation boxes
 *    are instruction-layer and are NEVER rendered as UI; the sentence, the
 *    primary, and the door are the caller's own lawful copy, never a mockup tag.
 *
 * REUSE, NEVER FORK: this composes the ONE shared NEXT-band primitive
 * (ui/NextActionEdge) unchanged -- the derived sentence, the primary's
 * label/handler, the door target, and the composer content ALL arrive via
 * props from data the caller already computes. This kit adds no derivation and
 * fetches nothing (a second NEXT-band renderer would be a DUPLICATE-WRITER
 * defect). It is the archetype's named entry point so a future record page
 * (Patient 360, the COC recovery console, Money detail) gets the same band by
 * citation instead of re-interpreting the mockup.
 */
import NextActionEdge, {
  type NextActionEdgeProps,
} from '@/dashboard/ui/NextActionEdge';

export type KitNextBandProps = NextActionEdgeProps;

export default function KitNextBand(props: KitNextBandProps): JSX.Element {
  return <NextActionEdge {...props} />;
}
